// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__2gzps","footer":"ModalCreateQualiphyProcedure_footer__2HblF","additionData":"ModalCreateQualiphyProcedure_additionData__2Jjmb"};